import React from "react";
import "./PrivacyPolicy.css"; // Use the same CSS

function RefundPolicy() {
  return (
    <div className="legal-container">
    <h1>Refund Policy</h1>
      <div className="legal-content">

        <h2>1. 14-Day Money-Back Guarantee</h2>
        <p>
          We offer a 14-day money-back guarantee on all paid plans. If you are not satisfied with Pipelyze, you may request a full refund within 14 days of your original purchase.
        </p>

        <h2>2. Refund Eligibility</h2>
        <ul>
          <li>Refund requests must be made within 14 days of purchase.</li>
          <li>Only first-time purchases are eligible for a refund; renewals are not eligible.</li>
          <li>Accounts found to be in violation of our <a href="/terms">Terms of Service</a> are not eligible for a refund.</li>
        </ul>

        <h2>3. How to Request a Refund</h2>
        <p>
          To request a refund, email <a href="mailto:support@pipelyze.com">support@pipelyze.com</a> with your account details and the reason for your request.
        </p>

        <h2>4. Processing Refunds</h2>
        <p>
          Approved refunds will be processed back to your original payment method within 5-10 business days.
        </p>

        <h2>5. Contact</h2>
        <p>
          If you have any questions about this policy, please contact us at <a href="mailto:support@pipelyze.com">support@pipelyze.com</a>.
        </p>

        <div className="legal-footer">Last updated: July 20, 2025</div>
      </div>
    </div>
  );
}

export default RefundPolicy;
